import React from 'react'

function NoFavorites() {
    return (
        <div className = "noFavorites">
            No favorites recipes....yet!
        </div>
    )
}

export default NoFavorites
